module.exports = __webpack_public_path__ + "static/media/netflix-wide.8958678f.png";